export default __webpack_public_path__ + "static/media/dog.0551e53a.svg";